// Shared date/time formatters — always render in Indian Standard Time (Asia/Kolkata)
// with the day-first format DD/MM/YYYY that the Brothers Advertising team uses.
const IST = "Asia/Kolkata";

const _dateFmt = new Intl.DateTimeFormat("en-GB", {
  timeZone: IST,
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

const _timeFmt = new Intl.DateTimeFormat("en-GB", {
  timeZone: IST,
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export function fmtDate(input) {
  if (!input) return "";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "";
  return _dateFmt.format(d); // DD/MM/YYYY
}

export function fmtDateTime(input) {
  if (!input) return "";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "";
  return `${_dateFmt.format(d)}, ${_timeFmt.format(d)} IST`;
}

export function fmtTime(input) {
  if (!input) return "";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "";
  return _timeFmt.format(d);
}

export const IST_TZ = IST;
